import axios from 'axios'
import { _local } from '../utils/storage'
import router from '../router/index'
import { ElMessage } from "element-plus";
//axios.create 创建一个axios实例  我们给这个实例编写配置，后续所有通过实例发送的请求，都受当前配置约束
const $http = axios.create({
  // baseURL: 'http://192.168.0.149:20227/',
  //baseURL: 'http://192.168.0.156:8200/',
  // baseURL: 'https://cxcgapi.psy-hs.com/',
  baseURL: '',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
});

// 添加请求拦截器
$http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (_local.get("token")) {
    config.headers.Authorization = 'Scheme ' + _local.get("token")
  } else {
    config.headers.Authorization = 'Scheme ';
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
$http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response.data;
}
  , function (error) {
    // 对响应错误做点什么
    if (error.response) {
      if (error.response.status == "401") {
        _local.clear();
        ElMessage.error("请登录");
        router.push('/login')
        return Promise.reject(error);
      }
    }
    else if (error.request) {
      console.log(error.request);
      if (error.request.readyState == 4 && error.request.status == 0) {
        ElMessage.error("请求超时");
      }
    }
    else {
      console.log('Error', error.message);
    }
    return Promise.reject(error);
  });

export default $http